import { Component, OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-finishes',
  templateUrl: './finishes.component.html',
  styleUrls: ['./facilities.component.scss']
})

export class FinishesComponent extends SeoAwareBaseComponent implements OnInit {
  public reasons: any[] = [];
  translateSubscription: Subscription = new Subscription();
  subscription: Subscription = new Subscription();

  constructor(
    public injector: Injector,
    public translateService: TranslateService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.meta.addTags([
      { name: 'robots', content: 'noindex' }
    ]);
    this.setTitle('Finisajele Dream residence');
  }
}



// WEBPACK FOOTER //
// ./src/app/about-us/finishes.component.ts